<div>
    <div class="div-franja">
        <img src="./assets/img/logolinea-brcblanco-footer.svg" class="img-logo-mona">
    </div>
</div>
<div id="encustaSatisfaccion" class="div-modal-dialog">

    <!--********************************************************* PARTE 1 TITULO **********************************************-->
    <div>
        <div class="div-boton-cerrar-dialog"><button mat-button mat-dialog-close (click)="closeDialog()">X</button></div>
        <div><h1 class="metadata-titulo">Encuesta de satisfacción</h1></div>
    </div>

    <!--********************************************************* PARTE 3 CONTENIDO **********************************************-->
    <!--*ngIf="detalleEncuesta.tipoEncuesta == constante.TIPO_ENCUESTA_BASICA"-->
    <div id="tipoEncuestaNormal" >
        <div class="div-contenedor-calificacion" *ngIf="!isAgradecimientos">
            <div class="div-texto-info">
                <div>
                    <h2 class="h-subtitulo">Califica qué tan útil fue este servicio de información</h2>
                </div>
            </div>
            <div class="div-formulario-calificacion">
                <mat-radio-group [(ngModel)]="calificacion">
                    <mat-radio-button class="radio-opcion-calificacion" value="MUY_UTIL"><img src="./assets/img/satisfaccion_muy_satisfecho.png" class="img-calificacion"/><br><span>Muy útil</span></mat-radio-button>
                    <mat-radio-button class="radio-opcion-calificacion" value="UTIL"><img src="./assets/img/satisfaccion_satisfecho.png" class="img-calificacion"/><br><span>Útil</span></mat-radio-button>
                    <mat-radio-button class="radio-opcion-calificacion" value="POCO_UTIL"><img src="./assets/img/satisfaccion_insatisfecho.png" class="img-calificacion"/><br><span>Poco útil</span></mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="div-razon-calificacion">
                <label>Por favor indiquenos la razón de su calificación:</label>
                <textarea name="razonCalificación" id="razonCalificacion" [(ngModel)]="razonCalificacion" class="textarea-razon-calificacion" ></textarea>
            </div>
        </div>
    </div>

    <div id="tipoEncuestaCertificada" >
        <div class="contenedor" *ngIf="!isAgradecimientos">
            <div>
                <div class="div-label-texto-intermedio"><label>En su experiencia como califica los siguientes aspectos
                        (en escala de 1 a 5 donde 1 es totalmente insatisfecho y 5 totalmente satisfecho)</label></div>
                <div>
                    <div><label>{{PREGUNTA_FACILIDAD}}</label></div>
                    <div><mat-radio-group [(ngModel)]="facilidad">
                            <mat-radio-button value="1">1</mat-radio-button>
                            <mat-radio-button value="2">2</mat-radio-button>
                            <mat-radio-button value="3">3</mat-radio-button>
                            <mat-radio-button value="4">4</mat-radio-button>
                            <mat-radio-button value="5">5</mat-radio-button>
                        </mat-radio-group></div>
                </div>
                <div>
                    <div><label>{{PREGUNTA_ORGANIZACION}} </label>
                    </div>
                    <div><mat-radio-group [(ngModel)]="organizacion">
                            <mat-radio-button value="1">1</mat-radio-button>
                            <mat-radio-button value="2">2</mat-radio-button>
                            <mat-radio-button value="3">3</mat-radio-button>
                            <mat-radio-button value="4">4</mat-radio-button>
                            <mat-radio-button value="5">5</mat-radio-button>
                        </mat-radio-group></div>
                </div>
                <div class="div-radio-group">
                    <div><label>{{PREGUNTA_UTILIDAD}} </label></div>
                    <div><mat-radio-group [(ngModel)]="utilidad">
                            <mat-radio-button value="1">1</mat-radio-button>
                            <mat-radio-button value="2">2</mat-radio-button>
                            <mat-radio-button value="3">3</mat-radio-button>
                            <mat-radio-button value="4">4</mat-radio-button>
                            <mat-radio-button value="5">5</mat-radio-button>
                        </mat-radio-group></div>
                </div>

                <div>
                    <div><label>¿{{PREGUNTA_ACTIVIDAD_ECONOMICA}}?</label></div>
                    <div><select class="select-lista-filtro" [(ngModel)]='actividadEconomica'
                            name="tipoPublicacionSelected" id="tipoPublicacionSelected">
                            <option value="" selected="selected">- Seleccionar -</option>
                            <option value="Sector público">Sector público</option>
                            <option value="Judicial">Judicial</option>
                            <option value="Prensa y medios">Prensa y medios</option>
                            <option value="Sector financiero">Sector financiero</option>
                            <option value="Organismo multilateral">Organismo multilateral</option>
                            <option value="Centros de investigación, Academia, Educación">Centros de investigación,
                                Academia, Educación</option>
                            <option value="Industria, comercio y servicios">Industria, comercio y servicios</option>
                            <option value="Otros">Otros</option>
                        </select></div>
                </div>
                <div>
                    <div><label>¿{{PREGUNTA_OCUPACION}}?</label></div>
                    <div><select class="select-lista-filtro" [(ngModel)]='ocupacion' name="tipoPublicacionSelected"
                            id="tipoPublicacionSelected">
                            <option value="" selected="selected">- Seleccionar -</option>
                            <option value="Estudiante">Estudiante</option>
                            <option value="Académico">Académico</option>
                            <option value="Analista económico y/o financiero">Analista económico y/o financiero</option>
                            <option value="Empleado público">Empleado público</option>
                            <option value="Abogado">Abogado</option>
                            <option value="Investigador">Investigador</option>
                            <option value="Inversionista">Inversionista</option>
                            <option value="Otro">Otro</option>
                        </select></div>
                </div>
                <div>
                    <div><label>¿{{PREGUNTA_PROPOSITO}}?</label></div>
                    <div><select class="select-lista-filtro" [(ngModel)]='proposito' name="tipoPublicacionSelected"
                            id="tipoPublicacionSelected">
                            <option value="" selected="selected">- Seleccionar -</option>
                            <option value="Redistribuir la información">Redistribuir la información</option>
                            <option value="Investigación / trabajos académicos">Investigación / trabajos académicos
                            </option>
                            <option value="Intereses personales">Intereses personales</option>
                            <option value="Asuntos legales">Asuntos legales</option>
                            <option value="Análisis y toma de decisiones">Análisis y toma de decisiones</option>
                            <option value="Otros">Otros</option>
                        </select></div>
                </div>
                <div>
                    <div><label>¿{{PREGUNTA_FRECUENCIA}}?</label></div>
                    <div><select class="select-lista-filtro" [(ngModel)]='frecuencia' name="tipoPublicacionSelected"
                            id="tipoPublicacionSelected">
                            <option value="" selected="selected">- Seleccionar -</option>
                            <option value="Ocasionalmente">Ocasionalmente</option>
                            <option value="Periódicamente(cada vez que se actualiza o publica la información)">
                                Periódicamente(cada vez que se actualiza o publica la información)</option>
                        </select></div>
                </div>

            </div>
            <div class="div-texto-info">
                <div>
                    <p>Si tiene alguna sugerencia, petición de información adicional, queja, reclamo o felicitación
                        sobre el indicador o tema que está consultando,
                        le informamos que el Banco de la República cuenta con medios oficiales para su recepción, por lo
                        que solicitamos sean enviadas a través del
                        <a href="https://www.banrep.gov.co/atencion-ciudadano" target="_blank">Sistema de Atención a la
                            Ciudadanía</a> para poder darles la debida gestión.
                    </p>
                </div>
            </div>
            <mat-error *ngIf="camposRequeridos">
                Todos los campos son obligatorios. Por favor, complételos.
              </mat-error>
            
            <div class="div-button">
                <div class="div-boton" (click)="enviarCalificacion()">
                    <a>
                        <p>Enviar</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="div-agradecimientos" *ngIf="isAgradecimientos">
        <h2>Gracias por compartirnos tu opinión!</h2>
    </div>
    <div class="div-button"><button mat-button mat-dialog-close>Cerrar</button></div>
</div>